import {enc} from '@pg/sign'

export const promisic = (func) => (params = {}) => new Promise((resolve, reject) => {
    const args = Object.assign(params, {
        success: (res) => {
            resolve(res)
        }, fail: (error) => {
            console.error('error', error)
            reject(error)
        },
    })
    func(args)
})

class CmsRequest {
    constructor(cms = {}) {
        this.key = cms.key
        this.secret = cms.secret
        this.baseRestUrl = cms.url
        this.tenantId = cms.tenantId
    }

    /**
     * 请求cms
     * @param parameters
     * @returns {Promise<unknown>}
     */
    request(parameters = {}) {

        return new Promise(async (resolve, reject) => {
            const params = parameters
            const timestamp = Date.parse(new Date()) / 1000

            if (!params.data) {
                params.data = {}
            }

            if (!params.method) {
                params.method = 'GET'
            }

            if (params.mid) {
                params.data.id = params.mid
            }

            if (params.v) {
                params.data.versionId = params.v
            }

            params.data.tenantId = this.tenantId
            params.data.key = this.key
            params.data.timestamp = String(timestamp)
            params.data.nonce = `${parseInt(Math.random() * 100000)}`
            params.data.sig = enc(null, this.secret, params.data)
            delete params.data.apiKey

            const header = {}
            if (params.method !== 'GET') {
                header['Content-Type'] = 'application/json'
            }

            try {
                const res = await promisic(wx.request)({
                    url: this.baseRestUrl, data: params.data, method: params.method,
                })
                if (res.statusCode < 500) {
                    if (res.data.code === 0) {
                        let content = JSON.parse(res.data.data.content.replace(/\,(?!\s*?[\{\[\"\'\w])/g, ''))
                        return resolve(content)
                    } else {
                        reject(new Error(res.data.msg))
                    }
                }
                reject(new Error(res.statusCode))
            } catch (error) {
                reject(new Error('人数过多，请稍后再试'))
            }
        })
    }
}

export default CmsRequest;
